const debounceAsync = (fn, delay) => {
  let timeout;
  return (...args) =>
    new Promise((resolve, reject) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        fn(...args).then(resolve).catch(reject);
      }, delay);
    });
};

export default debounceAsync;